import { Attribute } from '@df/catalog/attribute/attribute';
import { IConfigData } from '@df/catalog/config/config.interfaces';
import { NICmsContentField } from '@icms/core/content';
import { ICmsContentService } from '@icms/core/content/icms-content.service';

export namespace NAttributeOrder {
    export const ID = 'attribute-order';
    export interface IData {
        attrs?: IContent[];
    }

    export interface IContent {
        attr: string;
        order?: IOption[];
    }

    export interface IOption {
        optionLabel: string;
    }
}
export interface IICmsConfigAttributeData extends IConfigData<NAttributeOrder.IData> {}
ICmsContentService.registerConfig({
    id: NAttributeOrder.ID,
    name: 'Attributes order',
    fields: [
        <NICmsContentField.IRepeaterField>{
            key: 'attrs',
            type: NICmsContentField.EFieldType.repeater,
            title: 'Attributes',
            itemName: 'Attribute',
            itemNameField: 'attr',
            fields: [
                <NICmsContentField.IRelationField>{
                    key: 'attr',
                    type: NICmsContentField.EFieldType.relation,
                    title: 'Attribute',
                    required: true,
                    options: {
                        title: 'Attribute',
                        type: 'attribute',
                        filter: (model: Attribute) => !!model.data?.code && !!model.data?.label
                    }
                },
                <NICmsContentField.IRepeaterField>{
                    key: 'order',
                    type: NICmsContentField.EFieldType.repeater,
                    title: 'Order',
                    itemName: 'Option',
                    itemNameField: 'optionLabel',
                    defaultSize: 0,
                    fields: [
                        <NICmsContentField.IField>{
                            key: 'optionLabel',
                            type: NICmsContentField.EFieldType.text,
                            title: 'Attribute option label',
                            required: true
                        }
                    ]
                }
            ]
        }
    ]
});
